var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCatalogue = function SvgIconCatalogue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.914 7.329v33.34a2.336 2.336 0 0 0 4.673 0V7.33a2.336 2.336 0 1 0-4.673 0M16.428 7.329v33.34a2.336 2.336 0 0 0 4.672 0V7.33a2.336 2.336 0 0 0-4.672 0M30.751 5.516a2.337 2.337 0 0 0-3.81 1.813v33.34a2.337 2.337 0 0 0 3.587 1.975l9.723-6.157a2.34 2.34 0 0 0 1.086-1.973V15.239c0-.703-.317-1.37-.863-1.813z"
  })));
};
export default SvgIconCatalogue;